module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "Logo.d59ea1f7.png";